(ns common.tol-b)

(defonce tol-b
  [[:tol-b-1  "Kasvinviljely ja kotieläintalous, riistatalous ja niihin liittyvät palvelut"]
   [:tol-b-2  "Metsätalous ja puunkorjuu"]
   [:tol-b-3  "Kalastus ja vesiviljely"]
   [:tol-b-5  "Kivihiilen ja ruskohiilen kaivu"]
   [:tol-b-6  "Raakaöljyn ja maakaasun tuotanto"]
   [:tol-b-7  "Metallimalmien louhinta"]
   [:tol-b-8  "Muu kaivostoiminta ja louhinta"]
   [:tol-b-9  "Kaivostoimintaa palveleva toiminta"]
   [:tol-b-10 "Elintarvikkeiden valmistus"]
   [:tol-b-11 "Juomien valmistus"]
   [:tol-b-12 "Tupakkatuotteiden valmistus"]
   [:tol-b-13 "Tekstiilien valmistus"]
   [:tol-b-14 "Vaatteiden valmistus"]
   [:tol-b-15 "Nahan ja nahkatuotteiden valmistus"]
   [:tol-b-16 "Sahatavaran sekä puu- ja korkkituotteiden valmistus (pl. huonekalut): olki- ja punontatuotteiden valmistus"]
   [:tol-b-17 "Paperin, paperi- ja kartonkituotteiden valmistus"]
   [:tol-b-18 "Painaminen ja tallenteiden jäljentäminen"]
   [:tol-b-19 "Koksin ja jalostettujen öljytuotteiden valmistus"]
   [:tol-b-20 "Kemikaalien ja kemiallisten tuotteiden valmistus"]
   [:tol-b-21 "Lääkeaineiden ja lääkkeiden valmistus"]
   [:tol-b-22 "Kumi- ja muovituotteiden valmistus"]
   [:tol-b-23 "Muiden ei-metallisten mineraalituotteiden valmistus"]
   [:tol-b-24 "Metallien jalostus"]
   [:tol-b-25 "Metallituotteiden valmistus (pl. koneet ja laitteet)"]
   [:tol-b-26 "Tietokoneiden sekä elektronisten ja optisten tuotteiden valmistus"]
   [:tol-b-27 "Sähkölaitteiden valmistus"]
   [:tol-b-28 "Muiden koneiden ja laitteiden valmistus"]
   [:tol-b-29 "Moottoriajoneuvojen, perävaunujen ja puoliperävaunujen valmistus"]
   [:tol-b-30 "Muiden kulkuneuvojen valmistus"]
   [:tol-b-31 "Huonekalujen valmistus"]
   [:tol-b-32 "Muu valmistus"]
   [:tol-b-33 "Koneiden ja laitteiden korjaus, huolto ja asennus"]
   [:tol-b-35 "Sähkö-, kaasu- ja lämpöhuolto, jäähdytysliiketoiminta"]
   [:tol-b-36 "Veden otto, puhdistus ja jakelu"]
   [:tol-b-37 "Viemäri- ja jätevesihuolto"]
   [:tol-b-38 "Jätteen keruu, käsittely ja loppusijoitus: materiaalien kierrätys"]
   [:tol-b-39 "Maaperän ja vesistöjen kunnostus ja muut ympäristönhuoltopalvelut"]
   [:tol-b-41 "Talonrakentaminen"]
   [:tol-b-42 "Maa- ja vesirakentaminen"]
   [:tol-b-43 "Erikoistunut rakennustoiminta"]
   [:tol-b-45 "Moottoriajoneuvojen ja moottoripyörien tukku- ja vähittäiskauppa sekä korjaus"]
   [:tol-b-46 "Tukkukauppa (pl. moottoriajoneuvojen ja moottoripyörien kauppa)"]
   [:tol-b-47 "Vähittäiskauppa (pl. moottoriajoneuvojen ja moottoripyörien kauppa)"]
   [:tol-b-49 "Maaliikenne ja putkijohtokuljetus"]
   [:tol-b-50 "Vesiliikenne"]
   [:tol-b-51 "Ilmaliikenne"]
   [:tol-b-52 "Varastointi ja liikennettä palveleva toiminta"]
   [:tol-b-53 "Posti- ja kuriiritoiminta"]
   [:tol-b-55 "Majoitus"]
   [:tol-b-56 "Ravitsemistoiminta"]
   [:tol-b-58 "Kustannustoiminta"]
   [:tol-b-59 "Elokuva-, video- ja televisio-ohjelmatuotanto, äänitteiden ja musiikin kustantaminen"]
   [:tol-b-60 "Radio- ja televisiotoiminta"]
   [:tol-b-61 "Televiestintä"]
   [:tol-b-62 "Ohjelmistot, konsultointi ja siihen liittyvä toiminta"]
   [:tol-b-63 "Tietopalvelutoiminta"]
   [:tol-b-64 "Rahoituspalvelut (pl. vakuutus- ja eläkevakuutustoiminta)"]
   [:tol-b-65 "Vakuutus-, jälleenvakuutus- ja eläkevakuutustoiminta (pl. pakollinen sosiaalivakuutus)"]
   [:tol-b-66 "Rahoitusta ja vakuuttamista palveleva toiminta"]
   [:tol-b-68 "Kiinteistöalan toiminta"]
   [:tol-b-69 "Lakiasiain- ja laskentatoimen palvelut"]
   [:tol-b-70 "Pääkonttorien toiminta: liikkeenjohdon konsultointi"]
   [:tol-b-71 "Arkkitehti- ja insinööripalvelut: tekninen testaus ja analysointi"]
   [:tol-b-72 "Tieteellinen tutkimus ja kehittäminen"]
   [:tol-b-73 "Mainostoiminta ja markkinatutkimus"]
   [:tol-b-74 "Muut erikoistuneet palvelut liike-elämälle"]
   [:tol-b-75 "Eläinlääkintäpalvelut"]
   [:tol-b-77 "Vuokraus- ja leasingtoiminta"]
   [:tol-b-78 "Työllistämistoiminta"]
   [:tol-b-79 "Matkatoimistojen ja matkanjärjestäjien toiminta: varauspalvelut"]
   [:tol-b-80 "Turvallisuus-, vartiointi- ja etsiväpalvelut"]
   [:tol-b-81 "Kiinteistön- ja maisemanhoito"]
   [:tol-b-82 "Hallinto- ja tukipalvelut liike-elämälle"]
   [:tol-b-84 "Julkinen hallinto ja maanpuolustus: pakollinen sosiaalivakuutus"]
   [:tol-b-85 "Koulutus"]
   [:tol-b-86 "Terveyspalvelut"]
   [:tol-b-87 "Sosiaalihuollon laitospalvelut"]
   [:tol-b-88 "Sosiaalihuollon avopalvelut"]
   [:tol-b-90 "Kulttuuri- ja viihdetoiminta"]
   [:tol-b-91 "Kirjastojen, arkistojen, museoiden ja muiden kulttuurilaitosten toiminta"]
   [:tol-b-92 "Rahapeli- ja vedonlyöntipalvelut"]
   [:tol-b-93 "Urheilutoiminta sekä huvi- ja virkistyspalvelut"]
   [:tol-b-94 "Järjestöjen toiminta"]
   [:tol-b-95 "Tietokoneiden, henkilökohtaisten ja kotitaloustavaroiden korjaus"]
   [:tol-b-96 "Muut henkilökohtaiset palvelut"]
   [:tol-b-97 "Kotitalouksien toiminta kotitaloustyöntekijöiden työnantajina"]
   [:tol-b-98 "Kotitalouksien eriyttämätön toiminta tavaroiden ja palvelujen tuottamiseksi omaan käyttöön"]
   [:tol-b-99 "Kansainvälisten organisaatioiden ja toimielinten toiminta"]
   [:tol-b-0  "Toimiala tuntematon"]])

(defonce options
         (->> tol-b
              (map (fn [[k l]]
                     {:key   k
                      :label l}))))

(defn get-label [key]
  (some #(when (= key (first %)) (second %)) tol-b))

(defn get-key [label]
  (some #(when (= label (second %)) (first %)) tol-b))
